'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Image = exports.Illustration = exports.Text = exports.Wrapper = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _H = require('UIComponents/elements/headings/H3');

var _H2 = _interopRequireDefault(_H);

var _UIIllustration = require('UIComponents/image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = exports.Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'DynamicSidebarstyles__Wrapper'
})(['position:relative;display:flex;flex-direction:column;align-items:center;text-align:center;max-width:350px;min-height:500px;margin:0 auto;']);

var Text = exports.Text = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'DynamicSidebarstyles__Text'
})(['font-weight:normal;']);

var Illustration = exports.Illustration = (0, _styledComponents2.default)(_UIIllustration2.default).withConfig({
  displayName: 'DynamicSidebarstyles__Illustration'
})(['margin:2rem auto;width:85%;max-height:240px;']);

var Image = exports.Image = (0, _styledComponents2.default)(_UIImage2.default).withConfig({
  displayName: 'DynamicSidebarstyles__Image'
})(['margin:2rem auto;width:85%;max-height:240px;']);

var Title = exports.Title = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'DynamicSidebarstyles__Title'
})(['font-weight:800;']);